import axios from "axios";
import authHeader from "./auth-header";
import { API_URL } from "./constants";

class CustomerFeedbackService {

  fetchQuestionsWithChoices(){
    return axios.get( `${API_URL}customer-feedback/get-questions-with-choices`, 
      {
        headers: authHeader(),
      }
    )
  }

}

export default new CustomerFeedbackService();